<template>
    <div class="lms__superadmin_customer_list_table">
        <component-table
            :labels="[
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="LmsSuperadminCustomerListTableItem"
            @emit-sort="handleSort"
        />
    </div>
</template>

<script>
import LmsSuperadminCustomerListTableItem from '@/components/lms/superadmin/customer/list/LmsSuperadminCustomerListTableItem'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  name: 'lms-superadmin-customer-list-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminCustomerListTableItem
    }
  },
  props: {
    items: {
      type: Array
    },
    sortQueryable: {
      type: Boolean
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomerlisttable.scss";
</style>
